import {Component, OnInit} from '@angular/core';
import {ComisionServices} from '../services/comision.services';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {CargoServices} from '../../CoreModule/services/cargo.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {forkJoin} from 'rxjs';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {CargoEntity} from '../../CoreModule/entities/cargo.entity';
import {ComisionModel} from '../models/comision.model';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import {TypeaheadMatch} from 'ngx-bootstrap';
import * as moment from 'moment';
import {error} from 'util';
import {EmpleadoComisionesModel} from '../models/empleado.comisiones.model';

@Component({
  selector:"comision-individual",
  templateUrl:"../templates/comision.individual.template.html"
})
export class ComisionIndividualComponent implements OnInit{
  codigoVendedor:string;
  documento:string = "";
  tiendas: TiendaEntity[] = [];
  cargo: CargoEntity;
  comision: ComisionModel;
  comisiones: ComisionModel[] = [];
  public emples: any[] = [];
  cSelectName: string = '';

  empleSelect:any;

  comisionCalculada:any;

  constructor(private cs: ComisionServices, private ts:TiendaServices, private es:EmpleadoServices, private cars:CargoServices, private spinner:NgxSpinnerService) {
  }

  ngOnInit() {
    this.spinner.show();

    forkJoin([this.ts.getAllTiendas(), this.cars.getCargo('5cbb7d63ff4e15868c9d19ba'), this.cs.getAllComisiones()]).subscribe((d: any) => {
      this.tiendas = d[0].data.tiendas;
      this.cargo = d[1].data.cargo;

      this.comisiones = d[2].data.comisiones;

      this.spinner.hide();
    });
  }

  buscarEmpleado(){
    this.spinner.show();
    this.es.devolverBusquedaEmpleado(this.codigoVendedor,"",this.documento).subscribe(d=>{
      this.spinner.hide();
      this.comisionCalculada = undefined;
      this.empleSelect = undefined;
      if(d.data.devolverTiendaDeEmpleado.length > 0)
        this.emples = d.data.devolverTiendaDeEmpleado;
      console.log(this.emples);
    })
  }

  seleccionarEmple(emple:any){
    this.empleSelect = emple;
    this.comisionCalculada = undefined;
  }

  async consultarComisionEmpleado(){

    if(this.empleSelect == undefined){
      alert("Debe seleccionar un colaborador para calcular su comisión");
      return;
    }

    if(this.comision == undefined){
      alert("Debe seleccionar un comisión para poder continuar");
      return;
    }

    this.spinner.show();

    let fecha1 = moment(this.comision.fechaInicio).seconds(0).millisecond(0);
    let fecha2 = moment(this.comision.fechaFin).seconds(0).millisecond(0);

    let result = await this.cs.getInfoEmpleadoCalendario(this.empleSelect.id, fecha1.format('DD-MM-YYYY'), fecha2.format('DD-MM-YYYY')).toPromise();


    if(result.errors){
      alert(result.errors[0].message);
      this.spinner.hide();
      return;

    }

    this.spinner.hide();
    if(result.data.infoMetaEmpleadoCalendario){
      let d = result.data.infoMetaEmpleadoCalendario;

      console.log(d);
      let empleCom = new EmpleadoComisionesModel();
      empleCom.mallas = d.mallas;
      empleCom.empleado = d.empleado;
      empleCom.pptoTienda = d.pptoTienda;
      empleCom.ventasTienda = d.ventasTienda;
      empleCom.fechaInicio = this.comision.fechaInicio;
      empleCom.fechaFin = this.comision.fechaFin;


      if (d.cargo)
        empleCom.cargo = d.cargo;
      else
        empleCom.cargo = this.cargo;

      // let sem53 = d.ventas.filter(v=> v.semana == "2022-53");
      //
      // sem53.map(s=>{
      //   s.fecha = moment(s.fecha).format("DD-MM-YYYY")
      // })
      //
      // console.log(sem53);

      empleCom.calcularComision(d.ventas, this.tiendas, fecha1, fecha2);

      empleCom.tiendaMaestra = d.tiendaMaestra;

      this.comisionCalculada = empleCom;

    }

  }

  async guardarComision(){
    this.spinner.show();
    let result = await this.cs.addEmpleComision(this.comision._id, this.comisionCalculada).toPromise();
    this.spinner.hide();


    alert("Información de comisión guardada con éxito");
  }

  comisionSelect(event: TypeaheadMatch) {
    this.comision = event.item;
    this.comisionCalculada = undefined;
  }
}
